import Cookies from 'js-cookie';

interface AuthTokens {
  access_token: string;
  refresh_token: string;
  id_token?: string;
  refresh_expires_in?: number;
}

// Куки авторизации живут месяц — одинаково при входе и при рефреше
const getCookieOptions = () => {
  const expires = new Date();
  expires.setMonth(expires.getMonth() + 1);
  return { expires, secure: true };
};

export const setAuthCookies = (tokens: AuthTokens) => {
  const options = getCookieOptions();
  const currentTime = Math.floor(Date.now() / 1000);
  // 1 — токен считается протухшим, RedirectAuthorization сразу сделает рефреш
  const tokenExpiry = tokens.refresh_expires_in ? currentTime + tokens.refresh_expires_in : 1;

  Cookies.set("access_token", tokens.access_token, options);
  Cookies.set("refresh_token", tokens.refresh_token, options);
  if (tokens.id_token) {
    Cookies.set("id_token", tokens.id_token, options);
  }
  Cookies.set("token_expiry", String(tokenExpiry), options);
};

export const clearAuthCookies = () => {
  Cookies.remove("access_token");
  Cookies.remove("id_token");
  Cookies.remove("refresh_token");
  Cookies.remove("token_expiry");
  Cookies.remove("SESSION", { path: "/", domain: ".edge-apps.com" });
  Cookies.remove("refresh_token", { path: "/", domain: ".edge-apps.com" });
};
